import Vue from 'vue'
import keyBy from 'lodash/keyBy'
import apiHelper from "../../utilities/apiObsHelpers";
import {
  apiLoadClosedCases,
  apiLoadAllClosedCases,
  apiCreateCensusPackage,
  apiLoadAllCensusPackages,
  apiSearchCensusPackages,
  apiDownloadCensusPackage,
  apiLoadPackagedCases,
  apiRebuildCensusPackage,
  apiSubmitCensusPackage
} from "../api/apiObservables";

export const GETTER_CLOSED_CASES         = 'submissions/getClosedCases';
export const GETTER_ALL_CLOSED_CASES     = 'submissions/getAllClosedCases';
export const GETTER_SELECTED_CASES       = 'submissions/getSelectedCases';
export const GETTER_ALL_CENSUS_PACKAGES  = 'submissions/getAllCensusPackages';
export const GETTER_PACKAGED_CASES       = 'submissions/getPackagedCases';
export const GETTER_CLOSED_CASES_PAGES   = 'submissions/getCasesPagination';
export const GETTER_PACKAGES_PAGES   = 'submissions/getPackagePagination';

export const GETTER_ISPACKAGING          = 'submissions/isPackaging';

export const MUTATE_SET_CLOSED_CASES         = 'submissions/setClosedCases';
export const MUTATE_SET_ALL_CLOSED_CASES     = 'submissions/setAllClosedCases';
export const MUTATE_SET_ALL_CENSUS_PACKAGES  = 'submissions/setAllCensusPackages';
export const MUTATE_SET_SELECTED_CASES       = 'submissions/setSelectedCases';
export const MUTATE_SET_PACKAGED_CASES       = 'submissions/setPackagedCases';
export const MUTATE_SET_ISPACKAGING          = 'submissions/setIsPackaging';
export const MUTATE_SET_PACKAGE_STATUS       = 'submissions/setPackageStatus';

export const ACTION_LOAD_CLOSED_CASES        = 'submissions/loadClosedCases';
export const ACTION_LOAD_ALL_CLOSED_CASES    = 'submissions/loadAllClosedCases';
export const ACTION_CREATE_CENSUS_PACKAGE    = 'submissions/createCensusPackage';
export const ACTION_LOAD_ALL_CENSUS_PACKAGES = 'submissions/loadAllCensusPackages';
export const ACTION_SEARCH_CENSUS_PACKAGE    = 'submissions/searchCensusPackages';
export const ACTION_DOWNLOAD_CENSUS_PACKAGE  = 'submissions/downloadCensusPackage';
export const ACTION_LOAD_PACKAGED_CASES      = 'submissions/loadPackagedCases';
export const ACTION_REBUILD_CENSUS_PACKAGE   = 'submissions/rebuildCensusPackage';
export const ACTION_SUBMIT_CENSUS_PACKAGE    = 'submissions/submitCensusPackage';

const state = {
  casesPagination : {},
  submissionsPagination : {},
  closedCases    : {},
  allClosedCases : {},
  selectedCases  : {},
  censusPackages : {},
  packagedCases  : {},
  isPackaging    : false
};

const getters = {
  [GETTER_CLOSED_CASES]: (state) => state.closedCases,
  [GETTER_ALL_CLOSED_CASES]: (state) => state.allClosedCases,
  [GETTER_SELECTED_CASES]: (state) => state.selectedCases,
  [GETTER_ALL_CENSUS_PACKAGES]: (state) => state.censusPackages,
  [GETTER_PACKAGED_CASES]: (state) => state.packagedCases,
  [GETTER_ISPACKAGING]: (state) => state.isPackaging,
  [GETTER_CLOSED_CASES_PAGES]: (state) => state.casesPagination,
  [GETTER_PACKAGES_PAGES]: (state) => state.submissionsPagination,
};

const mutations = {
  [MUTATE_SET_CLOSED_CASES]: (state, payload) => {
    state.closedCases = Object.assign({}, payload) ;
  },
  [MUTATE_SET_ALL_CLOSED_CASES]: (state, payload) => {
    state.allClosedCases = Object.assign({}, payload.result) ;
    state.casesPagination = {count: payload.count, offset:payload.offset};
  },
  [MUTATE_SET_SELECTED_CASES]: (state, payload) => {
    state.selectedCases = Object.assign({}, payload) ;
  },
  [MUTATE_SET_ALL_CENSUS_PACKAGES]: (state, payload) => {
    state.censusPackages = Object.assign({}, payload.result) ;
    state.submissionsPagination = {count: payload.count, offset:payload.offset};
  },
  [MUTATE_SET_PACKAGED_CASES]: (state, payload) => {
    state.packagedCases = Object.assign({}, payload);
  },
  [MUTATE_SET_ISPACKAGING]: (state, payload) => {
    state.isPackaging = payload;
  },
  [MUTATE_SET_PACKAGE_STATUS]: (state, {index, value}) => {
    state.censusPackages[index].status = value;
  }
};

const actions = {
  [ACTION_LOAD_CLOSED_CASES] : apiHelper.mutateResult(
    apiLoadClosedCases,
    MUTATE_SET_CLOSED_CASES,
    (data) => keyBy(data, '_id')),
  [ACTION_LOAD_ALL_CLOSED_CASES] : apiHelper.mutateResult(
    apiLoadAllClosedCases,
    MUTATE_SET_ALL_CLOSED_CASES,
    (data) => ({result:keyBy(data.result, '_id'), count: data.count, offset: data.offset})),
  [ACTION_CREATE_CENSUS_PACKAGE] : (context, payload) => {
    if (context.getters[GETTER_ISPACKAGING]) {
      console.log("Attempting to package while existing packaging is still on-going");
      return;
    }
    context.commit(MUTATE_SET_ISPACKAGING, true);
    return new Promise((resolve, reject) => {
      apiHelper.mutateResult(apiCreateCensusPackage)(context, payload)
        .then( (result)=> { context.commit(MUTATE_SET_ISPACKAGING, false); resolve(result) })
        .catch( (err)=> { context.commit(MUTATE_SET_ISPACKAGING, false); reject(err) });
    })
  },
  [ACTION_LOAD_ALL_CENSUS_PACKAGES] : apiHelper.mutateResult(
    apiLoadAllCensusPackages,
    MUTATE_SET_ALL_CENSUS_PACKAGES,
    (data) => ({result:keyBy(data.result, '_id'), count: data.count, offset: data.offset})),
  [ACTION_SEARCH_CENSUS_PACKAGE] : apiHelper.mutateResult(
    apiSearchCensusPackages,
    MUTATE_SET_ALL_CENSUS_PACKAGES,
    (data) => ({result:keyBy(data.result, '_id'), count: data.count, offset: data.offset})),
  [ACTION_DOWNLOAD_CENSUS_PACKAGE] : apiHelper.mutateResult(apiDownloadCensusPackage),
  [ACTION_REBUILD_CENSUS_PACKAGE] : apiHelper.mutateResult(apiRebuildCensusPackage),
  [ACTION_SUBMIT_CENSUS_PACKAGE]   : apiHelper.mutateResult(apiSubmitCensusPackage),
  [ACTION_LOAD_PACKAGED_CASES] : apiHelper.mutateResult(
    apiLoadPackagedCases,
    MUTATE_SET_PACKAGED_CASES,
    (data) => keyBy(data, '_id'))
};

export default {
  state,
  getters,
  mutations,
  actions
}


